// convertGraphqlError baut Messages der Form
// `<operation> / <fehler> / [path] / variables: {...} / graphql_error`.
// Bugsnag gruppiert per Default nach der Codestelle, und die ist fuer alle
// GraphQL-Fehler dieselbe (convertGraphqlError). So landen 401er, Timeouts und
// Not-Authorized-Fehler aller Queries in einem einzigen Error. Der Hash hier
// gruppiert stattdessen nach Operation und Fehlerart.

export const GRAPHQL_ERROR_FLAG = 'graphql_error'

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi

const normalizeReason = (reason) =>
  reason
    .replace(/RequestId:\s*\S+/gi, '')
    .replace(UUID, '<id>')
    .replace(/\s+/g, ' ')
    .trim()

export const getGraphqlGroupingHash = (message) => {
  if (
    typeof message !== 'string' ||
    !message.endsWith(`/ ${GRAPHQL_ERROR_FLAG}`)
  ) {
    return null
  }

  const [operation, reason] = message.split(' / ')
  if (!operation || !reason) return null

  return `graphql / ${operation} / ${normalizeReason(reason)}`
}
